import { useEffect, useState } from 'react';

import { AppRoutes } from 'src/pages/AppRoutes';

// Type the routes as strings so we can compare the routes to window.location.pathname which is a string
const publicRoutes = [
  AppRoutes.SignIn.split('/')[1],
  AppRoutes.ResetPassword.split('/')[1],
  AppRoutes.RegisterInvite.split('/')[1],
  AppRoutes.ForgotPassword.split('/')[1],
  // TODO: include the "NotFound" route
];

// this functionality is quite similar to the isPublic prop for requireAuth
// could be refactored in the future
// if you add a route to the const publicRoutes, make sure to set its isPublic prop in requireAuth to true as well
export const useIsPublic = (): boolean => {
  const [isPublic, setIsPublic] = useState(false);

  useEffect(() => {
    if (publicRoutes.indexOf(window.location.pathname.split('/')[1]) === -1) {
      setIsPublic(false);
    } else {
      setIsPublic(true);
    }
  }, []);
  return isPublic;
};
